<template>
  <FriedModal
    :size="post.media.length ? ModalSize.XXLarge : ModalSize.Large"
    :padded="false"
    @close="$emit('close')"
  >
    <PostDetails :post="post" :participants="participants" :owner="owner" view-only>
      <template #media>
        <PostMediaSlideshow
          v-if="post.media.length"
          :post-media="post.media"
          :selected-media-index="selectedMediaIndex"
          @media-load-error="$emit('media-load-error')"
        />
      </template>
    </PostDetails>
  </FriedModal>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import type { User } from '@getaccept/lib-shared-new/src/users/types/user';
import { ModalSize } from '@getaccept/fried-tofu';
import type { Post, Participant } from '../../types';
import PostDetails from './PostDetails.vue';
import PostMediaSlideshow from './PostMediaSlideshow.vue';

export default defineComponent({
  components: {
    PostDetails,
    PostMediaSlideshow,
  },
  props: {
    post: {
      type: Object as PropType<Post>,
      required: true,
    },
    participants: {
      type: Array as PropType<Participant[]>,
      default: () => [],
    },
    owner: {
      type: Object as PropType<User | Participant>,
      default: () => ({} as User | Participant),
    },
    selectedMediaIndex: {
      type: Number,
      default: 0,
    },
  },
  emits: ['close', 'media-load-error'],
  setup() {
    return {
      ModalSize,
    };
  },
});
</script>
